import { SxProps, Theme } from '@mui/system';

const classes = {
  // react-cookie-consent SETS color: white ON ITS CONTAINER, SO THE BANNER
  // TAKES ITS TEXT COLOR FROM THE APP PALETTE INSTEAD OF INHERITING IT
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: 'primary.inputLabel',
  },

  contentSubContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  content: {
    fontSize: '16px',
    fontWeight: 500,
    color: 'common.gray',
  },

  button: {
    '& .MuiButton-root': {
      minWidth: '160px',
    },
  },

  buttonsContainer: {
    display: 'flex',
    gap: '12px',
  },

  refuseButton: {
    color: 'primary.main',
    borderColor: 'primary.main',
    backgroundColor: 'common.white',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'common.secondaryButtonHover',
    },
  },

  acceptButton: {
    color: 'common.white',
    backgroundColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.main',
    },
  },

  displayNone: {
    display: 'none',
  },

  textContainer: {
    maxWidth: '953px',
    maxHeight: '164px',
    paddingTop: '8px',
  },

  headingContainer: {
    display: 'flex',
  },

  heading: {
    fontSize: '18px',
    fontWeight: 600,
    color: 'primary.inputLabel',
    paddingLeft: '6px',
  },

  privacyPolicyText: {
    paddingLeft: '4px',
    color: 'primary.main',
    textDecoration: 'none',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
